(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["shirokai-cart-landed-cost"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('shirokai-shipping-estimate')) {
    customElements.define('shirokai-shipping-estimate', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.country = this.querySelector('[data-country-input]');
        this.province = this.querySelector('[data-province-input]');
        this.zip = this.querySelector('[data-zip-input]');
        this.button = this.querySelector('[data-calculate]');
        this.message = this.querySelector('[data-message]');
        this.result = this.querySelector('[data-result]');
        this.rateSelect = this.querySelector('[data-rate-input]');
        this.country.value = this.dataset.country;
        if (!this.country.value) this.country.selectedIndex = 0;
        this.updateProvinces();
        this.country.addEventListener('change', () => { this.updateProvinces(); this.invalidate(); });
        this.province.addEventListener('change', () => this.invalidate());
        this.zip.addEventListener('input', () => this.invalidate());
        this.button.addEventListener('click', () => this.calculate());
        this.rateSelect.addEventListener('change', () => this.showTotal());
      }
      disconnectedCallback() { this.request?.abort(); }
      invalidate() {
        this.request?.abort();
        this.request = null;
        this.result.hidden = true;
        this.message.textContent = '';
        this.button.disabled = false;
      }
      updateProvinces() {
        let provinces = [];
        try { provinces = JSON.parse(this.country.selectedOptions[0]?.dataset.provinces || '[]'); } catch (_) {}
        this.province.replaceChildren(...provinces.map(([value, label]) => new Option(label, value)));
        this.querySelector('[data-province-wrap]').hidden = !provinces.length;
      }
      fingerprint(cart) {
        return JSON.stringify([cart.currency, cart.total_price, cart.items.map(item => [item.key, item.quantity, item.final_line_price])]);
      }
      async calculate() {
        this.invalidate();
        const request = new AbortController();
        this.request = request;
        this.button.disabled = true;
        this.message.textContent = this.dataset.loading;
        const timeout = setTimeout(() => request.abort(), 20000);
        const root = this.dataset.root.replace(/\/?$/, '/');
        const parameters = new URLSearchParams({
          'shipping_address[country]':this.country.value,
          'shipping_address[province]':this.province.value,
          'shipping_address[zip]':this.zip.value.trim()
        });
        const read = async (url, options = {}) => {
          const response = await fetch(url, {...options, signal:request.signal, headers:{Accept:'application/json'}, cache:'no-store'});
          if (!response.ok) throw new Error(this.dataset.error);
          return response.json();
        };
        try {
          const before = await read(root + 'cart.js');
          await read(root + 'cart/prepare_shipping_rates.json?' + parameters, {method:'POST'});
          let response = null;
          for (let attempt = 0; attempt < 10; attempt++) {
            response = await read(root + 'cart/async_shipping_rates.json?' + parameters);
            if (response !== null) break;
            await new Promise(resolve => setTimeout(resolve, 800));
          }
          if (!response || !Array.isArray(response.shipping_rates)) throw new Error(this.dataset.error);
          const after = await read(root + 'cart.js');
          if (this.fingerprint(before) !== this.fingerprint(after)) throw new Error(this.dataset.changed);
          this.cart = after;
          this.rates = response.shipping_rates.filter(rate => Number.isFinite(Number(rate.price)) && Number(rate.price) >= 0);
          if (!this.rates.length) throw new Error(this.dataset.none);
          const currency = window.Shopify?.currency;
          this.rates = this.rates.map(rate => {
            const sourceCurrency = rate.currency || this.dataset.baseCurrency;
            if (sourceCurrency === after.currency) return {...rate, price:Number(rate.price), converted:false};
            const exchangeRate = Number(currency?.rate);
            if (sourceCurrency !== this.dataset.baseCurrency || currency?.active !== after.currency || !Number.isFinite(exchangeRate) || exchangeRate <= 0) throw new Error(this.dataset.error);
            return {...rate, price:Math.round(Number(rate.price) * exchangeRate * 100) / 100, converted:true};
          });
          this.rates.sort((a,b) => Number(a.price) - Number(b.price));
          this.money = new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency:after.currency, currencyDisplay:'code'});
          this.rateSelect.replaceChildren(...this.rates.map((rate, i) => new Option((rate.presentment_name || rate.name) + ' — ' + (rate.converted ? '≈ ' : '') + this.money.format(Number(rate.price)), String(i))));
          this.showTotal();
          this.result.hidden = false;
          this.message.textContent = '';
        } catch (error) {
          if (this.request === request && this.isConnected) this.message.textContent = error.name === 'AbortError' ? this.dataset.error : error.message;
        } finally {
          clearTimeout(timeout);
          if (this.request === request) this.button.disabled = false;
        }
      }
      showTotal() {
        const rate = this.rates[Number(this.rateSelect.value)];
        if (rate) this.querySelector('[data-total]').textContent = (rate.converted ? '≈ ' : '') + this.money.format(this.cart.total_price / 100 + Number(rate.price));
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["shirokai-cart-note"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('shirokai-cart-note')) {
    customElements.define('shirokai-cart-note', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.queue = Promise.resolve();
        const textarea = this.querySelector('textarea');
        const save = () => {
          const note = textarea.value;
          this.queue = this.queue.catch(() => {}).then(async () => {
            try {
              const response = await fetch(this.dataset.root.replace(/\/?$/, '/') + 'cart/update.js', {
                method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({note})
              });
              if (!response.ok) throw new Error('save');
              const cart = await response.json();
              if ((cart.note || '') !== note) throw new Error('save');
              if (this.isConnected && textarea.value === note) this.querySelector('[data-note-status]').textContent = this.dataset.saved;
            } catch (_) {
              if (this.isConnected) this.querySelector('[data-note-status]').textContent = this.dataset.error;
            }
          });
        };
        textarea.addEventListener('input', () => { clearTimeout(this.saveTimer); this.saveTimer = setTimeout(save, 250); });
        textarea.addEventListener('change', () => { clearTimeout(this.saveTimer); save(); });
      }
      disconnectedCallback() { clearTimeout(this.saveTimer); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["shirokai-product-availability"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('shirokai-availability')) {
    customElements.define('shirokai-availability', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const select = this.closest('form')?.querySelector('.product-variants-selector-select');
        if (!select || this.dataset.preorder === 'true') return;
        const update = () => {
          const option = select.selectedOptions[0];
          let key = 'leadTime';
          if (!option || option.value === 'none' || option.dataset.available === 'false') key = 'unavailable';
          else if (option.dataset.inventoryManagement && Number(option.dataset.inventoryQuantity) > 0) key = 'stock';
          this.dataset.status = key;
          this.textContent = this.dataset[key];
        };
        select.addEventListener('change', update, {signal:this.controller.signal});
        update();
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
